// "Call Do Not Disturb" schedule (Edit Profile -> Calls). While it is active, incoming calls are
// auto-declined as busy on the device, the caller is told up front, and the server skips the FCM ring push.
// Times are stored as minutes after local midnight (0-1439) plus the person's UTC offset at save time, so
// the server (which has no idea what time zone someone is in) can evaluate the same window the device does.
// A window may wrap past midnight (e.g. 23:00 -> 07:00).
export type CallDnd = { on?: boolean; start?: number; end?: number; tz?: number }

export function isCallDndActive(d: CallDnd | null | undefined, nowMs: number = Date.now(), tzOffsetMin?: number): boolean {
  if (!d || d.on !== true) return false
  const start = Number(d.start), end = Number(d.end)
  if (!Number.isFinite(start) || !Number.isFinite(end) || start === end) return false
  const tz = typeof tzOffsetMin === 'number' ? tzOffsetMin : Number(d.tz) || 0
  const local = (((Math.floor(nowMs / 60000) + tz) % 1440) + 1440) % 1440
  return start < end ? local >= start && local < end : local >= start || local < end
}

export const minutesToTime = (m: number) => `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`
export const timeToMinutes = (t: string) => {
  const [h, m] = t.split(':').map(Number)
  return (Number.isFinite(h) ? h : 0) * 60 + (Number.isFinite(m) ? m : 0)
}
